import React, { Component } from "react";
import "../../Pages/Login/Login.css";
import Loading from "../../Pages/Signup/Loading";
import ReactPhoneInput from "react-phone-input-2";

const $ = window.$;
export class AddStaffModal extends Component {
  constructor() {
    super();
    this.state = {
      isCreatingTeam: false,
      createTeamState: "none",
      phoneNumber: "",
    };
    this.createTeam = this.createTeam.bind(this);
    this.handlePhoneInput = this.handlePhoneInput.bind(this);
  }

  componentDidMount() {
    if (this.props.isOpen) {
      $("#addStaffModal").modal({
        keyboard: false,
      });
      $("#addStaffModal").modal("show");
    } else {
      $("#addStaffModal").modal("hide");
    }
    $("#addStaffModal").on(
      "hidden.bs.modal",
      function(e) {
        this.props.modalClose();
      }.bind(this),
    );
  }

  createTeam(e) {
    e.preventDefault();
    // let phoneNumber = this.refs.phoneNumber.value;
    // this.props.handleInviteStaff(phoneNumber);
    this.props.handleInviteStaff(this.state.phoneNumber);
  }

  handlePhoneInput(value) {
    this.setState({
      phoneNumber: value,
    });
  }

  render() {
    return (
      <div
        id="addStaffModal"
        className="modal fade"
        tabIndex="-1"
        role="dialog"
        data-backdrop="false"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-body" style={{ paddingBottom: "0px" }}>
              <h5 className="hc-primary-text" style={{ fontSize: "1.25rem" }}>
                Add Member
              </h5>
              {/* <p style={{fontSize: "0.9em"}}>Message here</p> */}
              <div
                className="Form-Container"
                style={{ margin: "20px 0", maxWidth: "100%" }}
              >
                <div className="form-group">
                  {/* <div className="card">
                                    <input ref="phoneNumber" type="text" id="team" placeholder="Registered phone number" required/>
                                    <i className="fas fa-users hc-primary-text"></i>
                                </div> */}
                  <div className="card" style={{ paddingLeft: "0px" }}>
                    <ReactPhoneInput
                      placeholder="Registered phone number"
                      country={"us"}
                      defaultCountry={"us"}
                      enableLongNumbers={true}
                      onChange={this.handlePhoneInput}
                      value={this.state.phoneNumber}
                      inputStyle={{
                        width: "100%",
                        outline: "none",
                        boxShadow: "none",
                      }}
                      required
                    />
                  </div>
                </div>
                {!this.state.isCreatingTeam ? (
                  <div className="form-group" style={{ textAlign: "right" }}>
                    <button
                      style={{ marginRight: "10px" }}
                      className="btn btn-hubchart btn-hubchart-primary"
                      onClick={(e) => this.createTeam(e)}
                    >
                      Add
                    </button>
                    <button
                      type="button"
                      className="btn btn-hubchart btn-hubchart-close"
                      data-dismiss="modal"
                    >
                      Cancel
                    </button>
                  </div>
                ) : (
                  <div
                    className="form-group"
                    style={{
                      textAlign: "right",
                      position: "relative",
                      height: "40px",
                    }}
                  >
                    <Loading />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AddStaffModal;
